module.exports = __webpack_public_path__ + "static/img/erweima_ba.09b9d14.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erweima_ba.png
// module id = EtLM
// module chunks = 0